import { Response } from '@marketplace-web/shared/api-client'

import { BusinessAccountAddressesResp } from 'types/api/response/business-account-addresses-resp'

import { transformBusinessAccountAddressesDto } from 'data/transformers/business-account'

export const transformBusinessAccountAddressesResponse = (
  response: Response<BusinessAccountAddressesResp>,
) => ({
  addresses: transformBusinessAccountAddressesDto(response.addresses),
})
